import { Badge } from '@/components/ui/badge'
import { ORDER_STATUS, ORDER_STATUS_LABELS, REFUND_TYPE, REFUND_TYPE_LABELS } from '@/schemas/supplier'
import { cn } from '@/lib/utils'

interface OrderStatusBadgeProps {
  status: number
  refundType?: number
  className?: string
}

const statusColors: Record<number, string> = {
  [ORDER_STATUS.DELETED]: 'bg-gray-100 text-gray-600',
  [ORDER_STATUS.CANCELLED]: 'bg-gray-100 text-gray-600',
  [ORDER_STATUS.PENDING_PAYMENT]: 'bg-yellow-100 text-yellow-800',
  [ORDER_STATUS.PENDING_SHIPMENT]: 'bg-blue-100 text-blue-800',
  [ORDER_STATUS.SHIPPED]: 'bg-cyan-100 text-cyan-800',
  [ORDER_STATUS.COMPLETED]: 'bg-green-100 text-green-800',
  [ORDER_STATUS.REFUNDED]: 'bg-red-100 text-red-800',
}

// 退款状态颜色（优先于订单状态）
const refundTypeColors: Record<number, string> = {
  [REFUND_TYPE.REFUND_ONLY]: 'bg-orange-100 text-orange-800',
  [REFUND_TYPE.RETURN_REFUND]: 'bg-orange-100 text-orange-800',
  [REFUND_TYPE.REJECTED]: 'bg-gray-100 text-gray-600',
  [REFUND_TYPE.PENDING_RETURN]: 'bg-orange-100 text-orange-800',
  [REFUND_TYPE.RETURNING]: 'bg-orange-100 text-orange-800',
  [REFUND_TYPE.REFUNDED]: 'bg-red-100 text-red-800',
}

const orderRefundTypeLabels: Record<number, string> = {
  [REFUND_TYPE.REFUND_ONLY]: '退款中',
  [REFUND_TYPE.RETURN_REFUND]: '退货退款',
  [REFUND_TYPE.REJECTED]: '已拒绝',
  [REFUND_TYPE.PENDING_RETURN]: '待退货',
  [REFUND_TYPE.RETURNING]: '退货中',
  [REFUND_TYPE.REFUNDED]: '已退款',
}

export function OrderStatusBadge({ status, refundType = 0, className }: OrderStatusBadgeProps) {
  // 退款状态优先显示
  if (refundType > 0 && refundType !== REFUND_TYPE.REJECTED) {
    const label = orderRefundTypeLabels[refundType] || REFUND_TYPE_LABELS[refundType] || '未知退款状态'
    const colorClass = refundTypeColors[refundType] || 'bg-orange-100 text-orange-800'
    return (
      <Badge
        variant="outline"
        className={cn(colorClass, 'border-0 font-normal', className)}
      >
        {label}
      </Badge>
    )
  }

  const label = ORDER_STATUS_LABELS[status] || '未知状态'
  const colorClass = statusColors[status] || 'bg-gray-100 text-gray-600'

  return (
    <Badge
      variant="outline"
      className={cn(colorClass, 'border-0 font-normal', className)}
    >
      {label}
    </Badge>
  )
}
